const frogAsset = (fileName) =>
  `${process.env.REACT_APP_CDN_BASE_URL}/auction/frogs/${fileName}`;

const frogVariants = (baseName) => [
  frogAsset(`${baseName}.webp`),
  frogAsset(`${baseName}-v2.webp`),
  frogAsset(`${baseName}-v3.webp`),
];

export const AMBIENT_AUCTION_WHEEL_FROG_SCENES = [
  {
    id: 'auction-host-side-peek',
    images: frogVariants('auction-host-pepe'),
    animation: 'host-side-peek',
    duration: 5200,
  },
  {
    id: 'auction-bidder-bottom-peek',
    images: frogVariants('bidder-pepe'),
    animation: 'bidder-bottom-peek',
    duration: 5400,
  },
];

export const AUCTION_WHEEL_FROG_EVENT_SCENES = {
  spinning: {
    id: 'auction-wheel-operator-run',
    images: frogVariants('wheel-operator-pepe'),
    animation: 'operator-run',
    duration: 4200,
  },
  winner: {
    id: 'auction-wheel-winner-celebration',
    images: frogVariants('winner-pepe'),
    animation: 'winner-celebration',
    duration: 5600,
  },
  elimination: {
    id: 'auction-host-elimination-verdict',
    images: frogVariants('auction-host-pepe'),
    animation: 'elimination-verdict',
    duration: 4800,
  },
};

export const pickAuctionWheelFrogImage = (scene, random = Math.random) => {
  if (!scene || scene.images.length === 0) {
    return scene;
  }

  const index = Math.min(
    scene.images.length - 1,
    Math.floor(random() * scene.images.length),
  );

  return {
    ...scene,
    image: scene.images[index],
  };
};

export const pickNextAuctionWheelFrogScene = (
  scenes,
  previousSceneId,
  random = Math.random,
) => {
  const withoutPrevious = scenes.filter((scene) => scene.id !== previousSceneId);
  const candidates = withoutPrevious.length > 0 ? withoutPrevious : scenes;

  if (candidates.length === 0) {
    return null;
  }

  const index = Math.min(
    candidates.length - 1,
    Math.floor(random() * candidates.length),
  );
  return candidates[index];
};
